var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "left" }, [
    _c(
      "div",
      { staticClass: "el-card__header clearfix" },
      [
        _c(
          "el-row",
          { staticClass: "title" },
          [
            _c("el-col", { staticClass: "material", attrs: { span: 12 } }, [
              _vm._v(" 物资分类 "),
            ]),
            _vm._v(" "),
            _c(
              "el-col",
              { staticClass: "text-right", attrs: { span: 12 } },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: "添加物资分类",
                      placement: "top",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "iconfont icontianjia pointer",
                      on: {
                        click: function ($event) {
                          return _vm.addDivsion()
                        },
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tree-box-con" }, [
      _c(
        "div",
        { directives: [{ name: "height", rawName: "v-height" }] },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.parentTree,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "filter-node-method": _vm.filterNode,
                  "default-expand-all": true,
                  "expand-on-click-node": false,
                  "icon-class": "el-icon-arrow-right",
                  "node-key": "value",
                },
                on: { "node-click": _vm.handleClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("div", { staticClass: "custom-tree-node" }, [
                        _c(
                          "div",
                          { staticClass: "flex-box" },
                          [
                            _c("span", { staticClass: "over-text" }, [
                              _vm._v(_vm._s(node.label)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                ref: "pop-" + data.value,
                                attrs: {
                                  placement: "bottom-end",
                                  trigger: "click",
                                  offset: 10,
                                },
                                on: {
                                  "after-enter": function ($event) {
                                    return _vm.handleShow(data.value)
                                  },
                                  hide: _vm.handleHide,
                                },
                              },
                              [
                                _c("div", { staticClass: "right-item-list" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-item",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.addDivsion(data)
                                        },
                                      },
                                    },
                                    [_vm._v("添加子类")]
                                  ),
                                  _vm._v(" "),
                                  data.value !== _vm.topId
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.editDivsion(data.value)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("public.edit")) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  data.value !== _vm.topId
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleDelete(data)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("public.delete")) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                data.value > 0
                                  ? _c("div", {
                                      staticClass:
                                        "iconfont icongengduo right-icon",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }